import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Sparkles, X, Search } from "lucide-react";
import { ScopeSelect, PLACEHOLDER } from "./ScopeSelect";
import AiSearchBody from "./AiSearchBody";

function Query({ req, onSearch }) {
  const [q, setQ] = useState(req.q || "");
  const [kind, setKind] = useState(req.kind || "all");
  const go = (e) => { e.preventDefault(); if (q.trim().length >= 2) onSearch({ q: q.trim(), kind }); };
  return (
    <form onSubmit={go} className="px-5 py-3 border-b border-border flex items-center gap-2">
      <div className="flex-1 min-w-0 flex items-center gap-2 pl-2 pr-2.5 h-10 bg-surface-2 border border-border rounded-sm focus-within:border-primary/60 transition-colors">
        <ScopeSelect value={kind} onChange={setKind} testid="ai-search-scope" />
        <Search size={14} className="text-muted shrink-0" />
        <input data-testid="ai-search-input" value={q} onChange={e => setQ(e.target.value)} maxLength={200} autoFocus={!req.q}
               placeholder={PLACEHOLDER[kind]} className="bg-transparent outline-none w-full min-w-0 text-sm placeholder:text-subtle" />
      </div>
      <button type="submit" data-testid="ai-search-submit" disabled={q.trim().length < 2}
              className="h-10 px-3.5 inline-flex items-center gap-1.5 bg-primary text-primary-fg rounded-sm text-[12.5px] font-semibold disabled:opacity-40 hover:opacity-90 active:scale-[0.97] transition-[opacity,transform]">
        <Sparkles size={13} /> <span className="hidden sm:inline">Search with AI</span>
      </button>
    </form>
  );
}

export default function AiSearchPanel({ req, onClose, onSearch }) {
  useEffect(() => {
    if (!req) return undefined;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [req, onClose]);
  if (!req) return null;
  return createPortal(
    <>
      <div data-testid="ai-search-backdrop" onClick={onClose} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[70] animate-fade-in" />
      <aside data-testid="ai-search-panel" role="dialog" aria-label="AI search"
             className="fixed top-0 right-0 h-screen w-full sm:w-[560px] lg:w-[620px] bg-bg border-l border-border shadow-2xl z-[71] flex flex-col fc-slide-in">
        <div className="px-5 pt-4 pb-3 border-b border-border flex items-start justify-between gap-4">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-[0.22em] text-primary font-semibold mb-1 inline-flex items-center gap-1.5"><Sparkles size={11} /> AI Search</div>
            <h2 className="font-display text-lg font-semibold tracking-tight leading-tight">SKUs, branches and suppliers</h2>
            <p className="text-[12px] text-muted mt-0.5">Insights and recommendations from cleaned Silver and Gold data only.</p>
          </div>
          <button type="button" data-testid="ai-search-close" onClick={onClose} aria-label="Close"
                  className="w-8 h-8 shrink-0 inline-flex items-center justify-center border border-border hover:border-primary hover:text-primary rounded-sm transition-colors">
            <X size={14} />
          </button>
        </div>
        <Query key={`q-${req.nonce}`} req={req} onSearch={onSearch} />
        <div className="flex-1 overflow-y-auto px-5 py-5"><AiSearchBody key={`b-${req.nonce}`} req={req} onSearch={onSearch} /></div>
      </aside>
    </>,
    document.body,
  );
}
